<div class="mc-spring-board">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    Pull Changes
    <span class="mc-fill-remaining-flex-space"></span>
    <button type="button" mat-icon-button tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"> </mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-form-body mc-d-flex mc-flex-column">
    <div class="mc-spring-board mc-min-height-0">
      <p class="mc-spring-board-header mc-form-section">
        External changes have been detected in the {{ data.filePaths?.length | mcPluralize: 'file' }} below. Pull to merge the changes into the {{ data.filePaths?.length === 1 ? 'file' : 'files' }}.
      </p>

      <div class="mc-spring-board-body mc-collab-pull-dialog-path-list-container">
        <mat-list class="mc-list-compact mc-form-section">
          <mat-list-item *ngFor="let filePath of data.filePaths">
            <mc-path-list-item [path]="filePath"></mc-path-list-item>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </div>

  <div class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="closeDialog()">Cancel</button>
      <button type="button" mat-raised-button color="primary" (click)="onPullClicked()">Pull</button>
    </div>
  </div>

  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</div>